import React from 'react';
import { useTranslation } from 'react-i18next';
import { getAssetPath } from '../../utils/publicPath';

import SectionTitle from '../../elements/section-title/SectionTitle';
import BlogListOne from '../../component/blog/BlogListOne';

const BlogOne = ({ variant = 'default' }) => {
  const { t } = useTranslation();

  if (variant === 'mutawir') {
    const cards = t('insights.cards', { returnObjects: true }) || [];

      return (
        <section id="insights" className="section section-padding bg-color-light mutawir-insights">
          <div className="container">
            <div className="row g-5 align-items-start mutawir-section-intro">
              <div className="col-xl-8 col-lg-9">
                <div className="mutawir-section-heading">
                  <span className="mutawir-tagline">{t('insights.tagline')}</span>
                  <h2 className="title">{t('insights.title')}</h2>
                  <p className="mutawir-section-description">{t('insights.description')}</p>
                </div>
              </div>
            </div>
            <div className="row g-4 mt--10">
              {cards.map((card, index) => (
                <div className="col-lg-4 col-md-6" key={index}>
                  <div className="mutawir-card mutawir-card--status">
                    {card.status && <div className="mutawir-card__status">{card.status}</div>}
                    <h3 className="mutawir-card__title">{card.title}</h3>
                    <p className="mutawir-card__description">{card.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      );
  }

  return (
    <div className="section section-padding-equal">
      <div className="container">
        <SectionTitle
          subtitle="What's Going On"
          title="Latest stories"
          description="News From Abstrak And Around The World Of Web Design And Complete Solution of Online Digital Marketing"
          textAlignment=""
          textColor=""
        />
        <div className="row g-0">
          <BlogListOne colSize="col-xl-6" itemShow="2" />
        </div>
      </div>
      <ul className="shape-group-1 list-unstyled">
        <li className="shape shape-1"><img src={getAssetPath('/images/others/bubble-1.png')} alt="bubble" /></li>
        <li className="shape shape-2"><img src={getAssetPath('/images/others/line-1.png')} alt="bubble" /></li>
        <li className="shape shape-3"><img src={getAssetPath('/images/others/line-2.png')} alt="bubble" /></li>
        <li className="shape shape-4"><img src={getAssetPath('/images/others/bubble-2.png')} alt="bubble" /></li>
      </ul>
    </div>
  );
};

export default BlogOne;
